export default "__VITE_ASSET__D48gA_C4__"